/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import noop from 'lodash/noop';

import { bool, func } from 'prop-types';
import React from 'react';

import { ReactComponent as CheckCircle } from 'assets/icons/check-circle.svg';
import LinkButton from 'components/shared/Buttons/LinkButton';
import { Link } from 'react-router-dom';

const ContainerButtons = ({ close, closeAndVerify, showOnlyUpdate, isInvalidMailing = false, has529, hasDeceased = false }) => (
  <div className="cmm-modal-buttons">
    <Link
      to="/profile/contact-information"
      className={'link-button'}
      onClick={close}>
      Update Information
    </Link>
    {!showOnlyUpdate && (
      <LinkButton onClick={closeAndVerify}>
        <span className="cmm-modal-icon-container">
          <CheckCircle className="cmm-modal-button-correct-icon" />
          This is correct
        </span>
      </LinkButton>
    )}
    {(!has529 && isInvalidMailing && !hasDeceased) &&(
        <button
            className={'link-button'}
            onClick={closeAndVerify}>
            Address on File is <br /> Correct
        </button>
    )}
  </div>
);

ContainerButtons.propTypes = {
  close: func.isRequired,
  closeAndVerify: func.isRequired,
  showOnlyUpdate: bool
};

ContainerButtons.defaultProps = {
  close: noop,
  showOnlyUpdate: false
};

export default ContainerButtons;
